import React from "react";

type FormInputProps = {
    label: string;
    name: string;
    type?: string;
    value: string;
    // eslint-disable-next-line no-unused-vars
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    error?: string;
    required?: boolean;
};

export default function FormInput({ label, name, type = "text", value, onChange, error, required }: FormInputProps) {
    return (
        <div className="col-span-2 md:col-span-1">
            <label className="block text-sm font-medium text-gray-700" htmlFor={name}>
                {label}
            </label>
            <input
                type={type}
                id={name}
                name={name}
                value={value}
                onChange={onChange}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                required={required}
            />
            {error && <p className="text-red-500 text-sm">{error}</p>}
        </div>
    );
}
